// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.block-video-popup[data-v-7dcb1c08] .content{display:flex;justify-content:center;align-items:center;background-color:rgba(0,0,0,.5)}.block-video-popup[data-v-7dcb1c08] .container.is-fullwidth .hide{right:2rem;top:2rem}.block-video-popup[data-v-7dcb1c08] .container.is-fullwidth .hide .hide-icon{color:#f2f2f5}.block-video-popup__container[data-v-7dcb1c08]{aspect-ratio:16/9;max-width:80%;width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
